var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 27.8906C13.2469 27.0281 13.8188 25.2187 13.3781 24.1594C12.9375 23.1 11.25 22.1719 11.25 21C11.25 19.8281 12.9188 18.9375 13.3781 17.8406C13.8375 16.7438 13.2469 14.9719 14.1094 14.1094C14.9719 13.2469 16.7813 13.8188 17.8406 13.3781C18.9 12.9375 19.8281 11.25 21 11.25C22.1719 11.25 23.0625 12.9188 24.1594 13.3781C25.2562 13.8375 27.0281 13.2469 27.8906 14.1094C28.7531 14.9719 28.1813 16.7813 28.6219 17.8406C29.0625 18.9 30.75 19.8281 30.75 21C30.75 22.1719 29.0813 23.0625 28.6219 24.1594C28.1625 25.2562 28.7531 27.0281 27.8906 27.8906C27.0281 28.7531 25.2187 28.1813 24.1594 28.6219C23.1 29.0625 22.1719 30.75 21 30.75C19.8281 30.75 18.9375 29.0813 17.8406 28.6219C16.7438 28.1625 14.9719 28.7531 14.1094 27.8906Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 18.75L19.6219 24L16.875 21.375",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.32ecc03f8f2e2fc0059d5bf8e23c58a6.svg";
export { ForwardRef as ReactComponent };